import { ContactInfoColumns } from "./contactInfoColumns";

export const initialBiobankColumns: Record<string, any>[] = [
  { 
    label: "Id:",
    column: "id",
    type: "string",
    showCopyIcon: true 
  },
  {
    label: "Identifier:",
    column: "pid",
    type: "string",
  },
  {
    label: "Description:",
    column: "description",
    type: "array",
  },
  {
    label: "Applicable Legislation:",
    column: "applicableLegislation",
    type: "hyperlink",
  },
  {
    label: "Release Date:",
    column: "issued",
    type: "date",
  },
  { 
    label: "Modification Date:",
    column: "modified",
    type: "date",
  },
  {
    label: "Geographical Coverage:",
    column: { spatial: ["label", "ontologyTermURI"] },
    type: "mref",
    showOnBiobankCard: true,
  },
  {
    label: "Temporal Coverage:",
    column: { temporal: ["id"] },
    type: "period",
  },
  {
    label: "Publisher:",
    column: { publisher: ["id", "name"] },
    type: "ref",
  },
  {
    label: "Frequency:", 
    column: { accrualPeriodicity: ["name", "label", "ontologyTermURI"] },
    type: "ref",
  },
  /** properties that are required but should not be rendered as attributes */
  {
    column: [
      "title",
      "pid",
      ...ContactInfoColumns,
    ],
  },
];

export default initialBiobankColumns;
